"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _Analytics = require("./Analytics");

var useAnalytics = function useAnalytics() {
  var _useContext = (0, _react.useContext)(_Analytics.AnalyticsContext),
      gtag = _useContext.gtag;

  return {
    sendEvent: function sendEvent(eventName, eventContext) {
      return gtag('event', eventName, eventContext);
    }
  };
};

var _default = useAnalytics;
exports.default = _default;